import React from "react";

function VulscanTableHeader() {

    return (
        <div className="network-scan-table-header-v2">
            <div>
                <h2 className="network-scan-title-v2">Nmap Scan List</h2>
                <p className="network-scan-subtitle-v2">Vulnerability scans, schedules and recent results</p>
            </div>
        </div>
    );
}

export default VulscanTableHeader;
